import { Component, OnInit, ViewChild } from '@angular/core';
import { DynamicFormComponent } from '../../_shared/components/dynamic-form/dynamic-form.component';
import { FieldConfig } from '../../_models/field.interface';
import { Router } from '@angular/router';
import { FidelidadeService } from '../../_services/fidelidade.service';
import { NotificationsService } from '../../_services/notifications.service';
import { Items, Payload, Pedidos } from '../../_models/pedidos';
import { DatePipe, Location } from '@angular/common';
import { faTheRedYeti } from '@fortawesome/free-brands-svg-icons';

@Component({
  selector: 'app-meuspedidos',
  templateUrl: './meuspedidos.component.html',
  styleUrls: ['./meuspedidos.component.scss'],
  providers: [],
})
export class MeusPedidosComponent implements OnInit {
  @ViewChild(DynamicFormComponent) form: DynamicFormComponent;

  regLabelMenuCacauLover: FieldConfig[];
  regUltimoPedido: FieldConfig[];
  regConfigCarousel: FieldConfig[] = [];
  itensMenuCarousel = [];
  regConfigHistorico: FieldConfig[];
  regHistoricoFiltro: FieldConfig[];

  regConfigSemDados: FieldConfig[] = [];

  //CONSTANTES
  readonly FILTRO_CINCO_DIAS: number = 5;
  readonly FILTRO_QUINZE_DIAS: number = 15;
  readonly FILTRO_TRINTA_DIAS: number = 30;
  readonly FILTRO_SESSENTA_DIAS: number = 60;
  readonly FILTRO_TOTAL: number = 0;

  pedidos: Pedidos[] = [];
  pedidosSemFiltro: Pedidos[] = [];
  pedidosFiltro: boolean = false;
  items: Items[];

  public carregandoPedidos: boolean = false;

  constructor(
    private fidelidadeService: FidelidadeService,
    private notificationsService: NotificationsService,
    private router: Router,
    public datepipe: DatePipe,
    private location: Location
  ) {
    this.notificationsService.notifyNotFound.subscribe((result) => {
      // this.regConfigHistorico = [
      //   {
      //     type: 'label',
      //     label: 'Pedidos não encontrado',
      //     style(): object {
      //       return {
      //         'font-weight': '600',
      //         'font-size': '24px',
      //         color: '#461F1A',
      //         'margin-top': '1rem',
      //         'margin-bottom': '2rem',
      //       };
      //     },
      //     onClick(): void {},
      //   },
      // ];
    });

    this.obterMeusPedidos(this.FILTRO_CINCO_DIAS);
    this.processarElementos();
    this.carregarSemDados();
  }

  obterMeusPedidos(dias) {
    this.regUltimoPedido = [];
    this.regConfigCarousel = [];
    this.regConfigHistorico = [];
    this.pedidosSemFiltro = [];

    this.carregandoPedidos = true;
    this.fidelidadeService.obterPedidos(dias).subscribe(
      (sucesso) => {
        this.pedidosFiltro = false;
        this.pedidosSemFiltro = sucesso;
        this.processarSucessoObterPedidos(sucesso);
      },
      (falha) => {
        this.processarFalhaObterPedidos(falha);
      }
    );
  }

  processarElementos() {
    this.regHistoricoFiltro = [
      {
        type: 'label',
        label: 'Histórico',
        style(): object {
          return {
            color: '#461F1A',
            'font-weight': 'bold',
            'font-size': '16px',
            'line-height': '14px',
            'margin-top': '30px',
          };
        },
      },
      {
        type: 'radioButtonCustom',
        label: '5 dias',
        name: 'option-5',
        class: 'option option-5',
        checked: true,
        onClick: () => this.obterMeusPedidos(this.FILTRO_CINCO_DIAS),
      },
      {
        type: 'radioButtonCustom',
        label: '15 dias',
        name: 'option-15',
        class: 'option option-15',
        checked: false,
        onClick: () => this.obterMeusPedidos(this.FILTRO_QUINZE_DIAS),
      },
      {
        type: 'radioButtonCustom',
        label: '1 mês',
        name: 'option-30',
        class: 'option option-30',
        checked: false,
        onClick: () => this.obterMeusPedidos(this.FILTRO_TRINTA_DIAS),
      },
      {
        type: 'radioButtonCustom',
        label: '2 meses',
        name: 'option-60',
        class: 'option option-60',
        checked: false,
        onClick: () => this.obterMeusPedidos(this.FILTRO_SESSENTA_DIAS),
      },
      {
        type: 'radioButtonCustom',
        label: 'Total',
        name: 'option-0',
        class: 'option option-0',
        checked: false,
        onClick: () => this.obterMeusPedidos(this.FILTRO_TOTAL),
      },
    ];
  }

  processarSucessoObterPedidos(
    response: any,
    filtro: boolean = false,
    productRefFiltro: string = ''
  ) {
    this.pedidos = [];
    this.items = [];
    if (response.length > 0) {
      for (let index = 0; index < response.length; index++) {
        var pedidos: Pedidos = new Pedidos();
        pedidos.Payload = new Payload();

        if (!filtro) {
          pedidos.Payload.Creation = response[index]['payload'].creation;
          pedidos.Payload.OrderRef = response[index]['payload'].orderRef;

          var loja = response[index]['payload'].loja.trim();
          if (loja !== undefined) pedidos.Payload.loja = loja;

          pedidos.Payload.Items = [];
          for (
            let item = 0;
            item < response[index]['payload'].items.length;
            item++
          ) {
            var itemArr: Items = new Items();
            itemArr.name = response[index]['payload'].items[item].name;
            itemArr.productRef =
              response[index]['payload'].items[item].productRef;
            itemArr.quantity = response[index]['payload'].items[item].quantity;
            pedidos.Payload.Items.push(itemArr);
            this.items.push(itemArr);
          }
          this.pedidos.push(pedidos);
        } else {
          pedidos.Payload.Creation = response[index]['Payload'].Creation;
          pedidos.Payload.OrderRef = response[index]['Payload'].OrderRef;

          var loja = response[index]['Payload'].loja;
          if (loja !== undefined) pedidos.Payload.loja = loja;

          pedidos.Payload.Items = [];
          for (
            let item = 0;
            item < response[index]['Payload'].Items.length;
            item++
          ) {
            var itemArr: Items = new Items();
            itemArr.name = response[index]['Payload'].Items[item].name;
            itemArr.productRef =
              response[index]['Payload'].Items[item].productRef;
            itemArr.quantity = response[index]['Payload'].Items[item].quantity;
            pedidos.Payload.Items.push(itemArr);
            this.items.push(itemArr);
          }
          this.pedidos.push(pedidos);
        }
      }

      this.pedidos = this.pedidos.sort(
        (a, b) =>
          new Date(b.Payload.Creation).getTime() -
          new Date(a.Payload.Creation).getTime()
      );

      var result = [];
      this.items.reduce(function (res, value) {
        if (!res[value.productRef]) {
          res[value.productRef] = {
            productRef: value.productRef,
            quantity: 0,
            name: value.name,
          };
          result.push(res[value.productRef]);
        }
        res[value.productRef].quantity += value.quantity;
        return res;
      }, {});

      this.items = result.sort(function (a, b) {
        return b.quantity - a.quantity;
      });

      this.regUltimoPedido = [];

      this.regUltimoPedido.push({
        type: 'label',
        label: 'Peça de novo',
        style(): object {
          return {
            color: '#461F1A',
            'font-weight': 'bold',
            'font-size': '16px',
            'line-height': '14px',
            'text-align': 'center',
            'margin-top': '20px',
          };
        },
      });

      for (
        let index = 0;
        index < this.pedidos[0].Payload.Items.length;
        index++
      ) {
        this.regUltimoPedido.push({
          type: 'label',
          styleDivPrincipal(): object {
            return { 'text-align': 'left' };
          },
          labels: [
            {
              type: 'label',
              label: this.pedidos[0].Payload.Items[index].quantity.toString(),
              style(): object {
                return {
                  color: '#461F1A',
                  'font-size': '12px',
                  'line-height': '14px',
                  height: '14px',
                  'text-align': 'center',
                  background: 'var(--pedido-circle-background-color)',
                  'border-radius': '500px',
                  'margin-left': '25px',
                  width: '14px',
                };
              },
              onClick(): void {},
            },
            {
              type: 'label',
              label: this.pedidos[0].Payload.Items[index].name,
              style(): object {
                return {
                  'font-size': '12px',
                  'line-height': '14px',
                  'text-align': 'left',
                  color: '#461F1A',
                  'margin-left': '15px',
                  height: '14px',
                };
              },
              onClick(): void {},
            },
          ],
        });
      }

      // this.regUltimoPedido.push({
      //   type: 'button',
      //   label: 'Comprar',
      //   style(): object {
      //     return {
      //       'background-color': '#461F1A',
      //       'color': '#F4B241',
      //       'font-weight': 'bold',
      //       'margin-top': '20px',
      //     };
      //   },
      //   onClick: () => this.comprarNovamente(),
      // });

      this.itensMenuCarousel = [];
      for (let index = 0; index < this.items.length; index++) {
        if (filtro)
          if (this.items[index].productRef != productRefFiltro) continue;

        if (index > 4) break;

        this.itensMenuCarousel.push({
          imgBackground: 'assets/images/others/menu_item_background.png',
          imgIcon: 'assets/images/icons/favorito.png',
          styleImgIcon(): object {
            return {
              position: 'absolute',
              top: '15%',
              left: '30%',
              height: '46px',
              width: '46px',
            };
          },
          styleLabel(): object {
            return {
              position: 'absolute',
              top: '55%',
              left: '5%',
              height: 'auto',
              width: '80px',
              'font-family': 'Sagona',
              'font-style': 'normal',
              'font-weight': 'normal',
              'font-size': '12px',
              'line-height': '14px',
              'text-align': 'left',
              'letter-spacing': '-0.01em',
              color: '#461F1A',
              float: 'left',
              'margin-left': '15px',
              'line-break': 'anywhere',
            };
          },
          label: this.items[index].name,
          onClick: () => this.filtrarMaisPedidos(this.items[index]),
          // link: 'http://localhost:4200/saibamais',
        });
      }

      this.regConfigCarousel = [
        {
          type: 'label',
          label: 'Mais pedidos por você',
          style(): object {
            return {
              color: '#461F1A',
              'font-family': 'Sagona',
              'font-style': 'normal',
              'font-weight': 'bold',
              'font-size': '16px',
              'line-height': '14px',
              'text-align': 'left',
              'letter-spacing': '-0.01em',
              'white-space': 'pre-line',
              float: 'left',
              width: '100%',
              height: '16px',
            };
          },
          styleDivPrincipal(): object {
            return {
              width: '90%',
            };
          },
        },
        {
          type: 'carousel',
          showArrows: false,
          maxSize: 120,
          height: 120,
          itensCarousel: this.itensMenuCarousel,
          styleDivPrincipal(): object {
            return {
              'text-align': '-webkit-center',
              'margin-top': '50px',
              'margin-left': '6px',
            };
          },
        },
        {
          type: 'button',
          label: 'Limpar Filtro',
          maxSize: 120,
          height: 120,
          visible: this.pedidosFiltro,
          onClick: () => this.limparFiltro(),
          styleDivPrincipal(): object {
            return {
              'text-align': '-webkit-center',
              'margin-top': '50px',
            };
          },
          style(): object {
            return {};
          },
        },
      ];

      this.regConfigHistorico = [];

      var dataAnterior: string = null;
      for (let index = 0; index < this.pedidos.length; index++) {
        var criarCabecalhoDia: boolean = true;
        if (dataAnterior != null) {
          if (
            dataAnterior ==
            this.datepipe.transform(
              this.pedidos[index].Payload.Creation,
              'dd/MM/yyyy',
              '',
              'pt-BR'
            )
          )
            criarCabecalhoDia = false;
          else criarCabecalhoDia = true;
        }

        dataAnterior = this.datepipe.transform(
          this.pedidos[index].Payload.Creation,
          'dd/MM/yyyy',
          '',
          'pt-BR'
        );

        if (criarCabecalhoDia) {
          this.regConfigHistorico.push({
            type: 'label',
            label: this.datepipe
              .transform(
                this.pedidos[index].Payload.Creation,
                'EEE d MMMM y',
                '',
                'pt-BR'
              )
              .replace('.', ' '),
            style(): object {
              return {
                'font-weight': 'normal',
                'font-size': '12px',
                'line-height': '14px',
                'text-align': 'center',
                color: '#461F1A',
                float: 'left',
                'margin-top': '10px',
                height: '14px',
                'text-transform': 'capitalize',
              };
            },
            styleDivPrincipal(): object {
              return {
                width: '90%',
                'margin-top': '10%',
                position: 'relative',
                display: 'block',
                clear: 'left',
              };
            },
          });
        }

        for (
          let indexItem = 0;
          indexItem < this.pedidos[index].Payload.Items.length;
          indexItem++
        ) {
          if (indexItem == 0) {
            if (criarCabecalhoDia) {
              this.regConfigHistorico.push({
                type: 'label',
                styleDivPrincipal(): object {
                  return {
                    position: 'relative',
                    display: 'flow-root',
                    width: '90%',
                    top: '5px',
                    background: '#ffffff',
                    border: '0.2px solid #000000',
                    'box-sizing': 'border-box',
                    'box-shadow': '0px 2px 2px rgba(0, 0, 0, 0.25)',
                    'border-radius': '10px',
                    'padding-bottom': '16px',
                    'padding-top': '20px',
                    'margin-bottom': '-35px',
                  };
                },
                labels: [
                  {
                    type: 'label',
                    label:
                      'Pedido #' +
                      this.pedidos[index].Payload.OrderRef +
                      '  -  ' +
                      this.pedidos[index].Payload.loja,
                    style(): object {
                      return {
                        color: '#461F1A',
                        'font-weight': 'bold',
                        'font-size': '16px',
                        'line-height': '14px',
                        'text-align': 'left',
                        float: 'left',
                        'margin-left': '25px',
                        width: '100%',
                        height: '16px',
                      };
                    },
                    styleDivPrincipal(): object {
                      return {};
                    },
                  },
                ],
              });
            } else {
              this.regConfigHistorico.push({
                type: 'label',
                styleDivPrincipal(): object {
                  return {
                    position: 'relative',
                    width: '90%',
                    top: '55px',
                    background: '#ffffff',
                    border: '0.2px solid #000000',
                    'box-sizing': 'border-box',
                    'box-shadow': '0px 2px 2px rgba(0, 0, 0, 0.25)',
                    'border-radius': '10px',
                    'padding-bottom': '16px',
                    'margin-bottom': '30px',
                  };
                },
                labels: [
                  {
                    type: 'label',
                    label: '#' + this.pedidos[index].Payload.OrderRef,
                    style(): object {
                      return {
                        color: '#461F1A',
                        'font-weight': 'bold',
                        'font-size': '16px',
                        'line-height': '14px',
                        'text-align': 'left',
                        float: 'left',
                        'margin-left': '25px',
                        width: '100%',
                        height: '16px',
                        'margin-top': '25px',
                      };
                    },
                    styleDivPrincipal(): object {
                      return {};
                    },
                  },
                ],
              });
            }
          }

          this.regConfigHistorico[
            this.regConfigHistorico.length - 1
          ].labels.push(
            {
              type: 'label',
              label:
                this.pedidos[index].Payload.Items[
                  indexItem
                ].quantity.toString(),
              styleDivPrincipal(): object {
                return {};
              },
              style(): object {
                return {
                  color: '#461F1A',
                  'font-family': 'Sagona',
                  'font-size': '12px',
                  'line-height': '14px',
                  height: '14px',
                  background: 'var(--pedido-circle-background-color)',
                  'border-radius': '500px',
                  float: 'left',
                  'margin-left': '25px',
                  width: '14px',
                  clear: 'left',
                  'margin-top': '6px',
                };
              },
              onClick(): void {},
            },
            {
              type: 'label',
              label: this.pedidos[index].Payload.Items[indexItem].name,
              styleDivPrincipal(): object {
                return {};
              },
              style(): object {
                return {
                  'font-size': '12px',
                  'line-height': '14px',
                  'text-align': 'left',
                  color: '#461F1A',
                  width: '80%',
                  height: '14px',
                };
              },
              onClick(): void {},
            }
          );
        }

        if (this.pedidos.length - 1 != index) {
          // this.regConfigHistorico.push({
          //   type: 'button',
          //   label: 'Comprar',
          //   style(): object {
          //     return {
          //       // 'display': 'block',
          //       'margin': 'auto',
          //       'background-color': '#461F1A',
          //       'color': '#F4B241',
          //       'font-weight': 'bold',
          //       'margin-top': '-15px'
          //     };
          //   },
          //   onClick: () => this.comprarNovamente(),
          // });
        } else {
          // this.regConfigHistorico.push({
          //   type: 'button',
          //   label: 'Comprar',
          //   style(): object {
          //     return {
          //       'background-color': '#461F1A',
          //       'color': '#F4B241',
          //       'font-weight': 'bold',
          //       'width': '126px',
          //       'height': '26px',
          //     };
          //   },
          //   onClick: () => this.comprarNovamente(),
          // });
        }
      }
    }

    this.carregandoPedidos = false;
  }

  comprarNovamente() {
    // this.router.navigate(['~index']);
  }

  processarFalhaObterPedidos(falha: any) {
    this.carregandoPedidos = false;
  }

  ngOnInit(): void {
    this.registrarElementosPagina();
  }

  // ***********************/
  // COMPONENTES DINAMICOS
  //************************/
  registrarElementosPagina() {
    this.regUltimoPedido = [];
    this.regConfigCarousel = [] = [];
    this.itensMenuCarousel = [];
    this.regConfigHistorico = [];
    this.regLabelMenuCacauLover = [
      {
        type: 'labelImage',
        label: 'Meus Pedidos',
        icon: ['assets/images/icons/voltar.png'],
        style(): object {
          return {
            'font-family': 'Sagona',
            'font-style': 'normal',
            'font-weight': '600',
            'font-size': '24px',
            color: '#461F1A',
            'padding-left': '50px',
            'padding-top': '19px',
          };
        },
        onClick: () => {
          this.location.back();
        },
      },
    ];
  }

  carregarSemDados(): void {
    this.regConfigSemDados = [
      {
        type: 'noData',
        src: 'assets/images/icons/caixa.png',
        title: 'Você ainda não tem nenhum pedido.',
        label: 'Experimente uma das nossas delícias.',
      },
    ];
  }

  filtrarMaisPedidos(item: Items) {
    var pedidosFiltro = this.pedidos.filter((pedido) => {
      return pedido.Payload.Items.some((i) => {
        return i.productRef === item.productRef;
      });
    });

    this.pedidosFiltro = true;
    this.processarSucessoObterPedidos(pedidosFiltro, true, item.productRef);
  }

  limparFiltro() {
    this.pedidosFiltro = false;
    this.processarSucessoObterPedidos(this.pedidosSemFiltro);
  }

  voltarPaginaAnterior() {
    this.location.back();
  }
}
